module.exports = __webpack_public_path__ + "static/img/amart.6a66bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MPAlogo/amart.png
// module id = hUAp
// module chunks = 49